import { getI18n } from "react-i18next";

const convertTo12HourFormat = (time) => {
  if (time === "Closed") return "Closed";

  let [hours, minutes] = time.split(":");
  hours = parseInt(hours, 10);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
  return `${hours}:${minutes} ${period}`;
};

const formatDaysList = (days, t) => {
  if (days.length <= 2) {
    return days.map((day) => t(`day.${day}`)).join(", ");
  }

  let groups: any = [];
  let currentGroup = [days[0]];

  for (let i = 1; i < days.length; i++) {
    const currentDayIndex = daysOrder.indexOf(days[i]);
    const prevDayIndex = daysOrder.indexOf(days[i - 1]);

    if (currentDayIndex === prevDayIndex + 1) {
      currentGroup.push(days[i]);
    } else {
      groups.push(currentGroup);
      currentGroup = [days[i]];
    }
  }
  groups.push(currentGroup);

  return groups
    .map((group) => {
      if (group.length > 2) {
        return `${t(`day.${group[0]}`)} - ${t(
          `day.${group[group.length - 1]}`
        )}`;
      }
      return group.map((day) => t(`day.${day}`)).join(", ");
    })
    .join(", ");
};

const daysOrder = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const convertHoursToObjectUpdated = async ({ hours, language }) => {
  // Get i18n instance directly instead of using the hook
  const i18n = getI18n();
  const t = i18n.t.bind(i18n);

  // Get maximum number of time slots
  const maxTimeSlots = Math.max(
    ...Object.values(hours).map((slots: any) => slots.length)
  );

  // First, group by time slots
  const groupedSlots = Array.from({ length: maxTimeSlots })
    .map((_, slotIndex) => {
      const daysForSlot = Object.entries(hours).reduce(
        (acc, [day, timeSlots]: any) => {
          const timeSlot = timeSlots[slotIndex];
          if (timeSlot && timeSlot.start !== "Closed") {
            const timeKey = `${timeSlot.start}-${timeSlot.end}`;

            if (!acc[timeKey]) {
              acc[timeKey] = {
                days: [],
                time: timeSlot,
              };
            }
            acc[timeKey].days.push(day);
          }
          return acc;
        },
        {}
      );

      return Object.values(daysForSlot);
    })
    .flat()
    .filter((group: any) => group && group.days.length > 0);

  // Sort groups by start time and then by number of days
  const sortedGroups = groupedSlots.sort((a: any, b: any) => {
    if (a.time.start === b.time.start) {
      return b.days.length - a.days.length;
    }
    return a.time.start.localeCompare(b.time.start);
  });

  // Convert to intermediate format
  const initialGroups = sortedGroups.map((group: any) => ({
    day: formatDaysList(
      group.days.sort(
        (a: any, b: any) => daysOrder.indexOf(a) - daysOrder.indexOf(b)
      ),
      t
    ),
    hours:
      language === "en"
        ? `${convertTo12HourFormat(group.time.start)} - ${convertTo12HourFormat(
            group.time.end
          )}`
        : `${group.time.start} - ${group.time.end} ${t("clock")}`,
  }));

  // Combine groups with same days
  const combinedGroups = initialGroups.reduce((acc: any, curr: any) => {
    const existingGroup = acc.find((group: any) => group.day === curr.day);
    if (existingGroup) {
      existingGroup.hours = Array.isArray(existingGroup.hours)
        ? [...existingGroup.hours, curr.hours]
        : [existingGroup.hours, curr.hours];
    } else {
      acc.push({
        day: curr.day,
        hours: [curr.hours],
      });
    }
    return acc;
  }, []);

  return combinedGroups;
};
